export default __webpack_public_path__ + "static/media/cat-placeholder-oval.b31dca91.png";